if (document.querySelectorAll('.js-lazy, .js-lazy-bg').length) {
  import(/* webpackChunkName: "lazy-images" */ './lazy');
}

if (document.querySelectorAll('.js-defer')) {
  import(/* webpackChunkName: "defer-images" */ './defer');
}
